import {  t  } from "@/client/libs/dummy-i18n";
import { Button } from "@stackmorph/ui";
import { motion } from "framer-motion";
import { Link } from "react-router";

import { Logo } from "@/client/components/logo";
import { useUser } from "@/client/services/user";

export const Header = () => {
  const { user, loading } = useUser();

  return (
    <motion.header
      className="fixed inset-x-0 top-0 z-50 bg-gradient-to-b from-background/80 to-transparent backdrop-blur-md"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <div className="container mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center space-x-2">
          <Logo size={32} />
          <span className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-cyan-600 bg-clip-text text-transparent">
            StackMorph
          </span>
        </Link>

        <div className="flex items-center space-x-4">
          {loading ? null : (user ? (
            <Button asChild size="sm" className="rounded-full">
              <Link to="/dashboard">{t`Dashboard`}</Link>
            </Button>
          ) : (
            <>
              <Button asChild variant="ghost" size="sm" className="rounded-full">
                <Link to="/auth/login">{t`Sign in`}</Link>
              </Button>
              <Button asChild size="sm" className="rounded-full bg-gradient-to-r from-indigo-600 to-cyan-600">
                <Link to="/auth/register">{t`Get Started Free`}</Link>
              </Button>
            </>
          ))}
        </div>
      </div>
    </motion.header>
  );
};
